
export function inputNumberWithUnit() {
  return {
    restrict: 'E',
    template: require('./input-number-with-unit.directive.html'),
    scope: {
      model: '=',
      placeholder: '@',
      unit: '@',
      readonly: '<',
      max: '<?'
    },
    controller: controller
  };
}

controller.$inject = ['$scope'];
function controller($scope) {
  // Work around ng-ifs and ng-repeats creating child scopes 
  // (see e.g. https://stackoverflow.com/questions/18342917/angularjs-ng-model-doesnt-work-inside-ng-if )
  $scope.directiveModel = {
    'value': $scope.model
  }
  // But in addition we need to forward any new value up to our parent scope 
  // (angular watches $scope.model because we delcared it with '=' in the directive definition)
  $scope.$watch("directiveModel.value", newValue => $scope.model = newValue);
} 